// extracted by mini-css-extract-plugin
export default {"square":"WorkerPopover_square__GkE+a"};